(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* SB Product Designer: ocultar la fila "Default Title" (cantidad/precio) y "Additional information" */
  (function () {
    var HEADINGS = ['additional information', 'informacion adicional', 'información adicional'];
    function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
    function isLeafText(el, txt) {
      return el.children.length === 0 && norm(el.textContent) === txt;
    }
    function hide(el) { if (el && el.style.display !== 'none') { el.style.display = 'none'; el.setAttribute('data-icase-hidden', ''); } }
    function scan() {
      var all = document.querySelectorAll('main div, main span, main p, main td, main label, main h1, main h2, main h3, main h4, main h5, main h6, main strong');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.closest('[data-icase-hidden]') || el.closest('[data-cart-drawer]')) continue;
        if (isLeafText(el, 'default title')) {
          var row = el, n = 0;
          while (row.parentElement && n < 6 && !row.querySelector('input, button')) { row = row.parentElement; n++; }
          if (row.querySelector('input, button') && !row.querySelector('[data-add], .product__form, form')) hide(row);
          continue;
        }
      }
      /* "Additional information": buscar el texto (aunque tenga ":" "*" o etiquetas internas) */
      var walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT);
      var node, found = [];
      while ((node = walker.nextNode())) {
        var txt = norm(node.nodeValue).replace(/[:*]/g, '').trim();
        if (HEADINGS.indexOf(txt) > -1) found.push(node.parentElement);
      }
      found.forEach(function (head) {
        if (!head || head.closest('[data-icase-hidden]')) return;
        var box = head, k = 0, target = null;
        while (box.parentElement && k < 5) {
          box = box.parentElement; k++;
          if (box.querySelector('textarea')) { target = box; break; }
        }
        var safe = target && !target.querySelector('canvas, .saveDesign, [data-add], .product__form, select, input, button, img') &&
                   target.querySelectorAll('textarea').length === 1 && norm(target.textContent).length < 120;
        if (safe) { hide(target); return; }
        hide(head);
        var ta = target ? target.querySelector('textarea') : null;
        if (ta) {
          var w = ta;
          while (w.parentElement && w.parentElement !== target && w.parentElement.children.length === 1) w = w.parentElement;
          hide(w);
        }
      });
    }
    var timer;
    function soon() { clearTimeout(timer); timer = setTimeout(scan, 120); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    if ('MutationObserver' in window) new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
  })();

  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-variants]', root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $('[data-cart-form]', root);
    var sticky = $('[data-sticky-atc]', root);
    var mainBtn = $('[data-add]', root);

    /* Precio de la barra fija = precio mostrado (incluye rebajas automaticas) */
    function syncStickyPrice() {
      var sp = sticky && $('[data-sticky-price]', sticky);
      var now = $('[data-price] .price__now', root);
      if (sp && now) sp.textContent = now.textContent;
    }
    syncStickyPrice();

    /* Variante elegida: nombre, SKU, stock y barra fija */
    if (form && variants.length > 1) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('.opt input')) return;
        var fs = e.target.closest('[data-option]');
        var chosenEl = fs && $('[data-chosen]', fs);
        if (chosenEl) chosenEl.textContent = e.target.value;
        var chosen = $$('[data-option]', form).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
        var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
        var sBtn = sticky && $('[data-sticky-add]', sticky);
        if (!v) { if (sBtn) sBtn.disabled = true; return; }
        var skuEl = $('[data-sku]', root);
        if (skuEl) { skuEl.hidden = !v.sku; var sv = $('[data-sku-value]', skuEl); if (sv) sv.textContent = v.sku || ''; }
        var stock = $('[data-stock]', root);
        if (stock && v.stock) stock.innerHTML = v.stock;
        if (sticky) {
          syncStickyPrice();
          sBtn.disabled = !v.available;
          var sl = $('[data-sticky-label]', sticky); if (sl) sl.textContent = v.available ? 'Agregar' : 'Agotado';
        }
      });
    }

    /* Barra fija: aparece cuando el botón principal sale de pantalla */
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = $('[data-sticky-add]', sticky); if (b) b.tabIndex = show ? 0 : -1;
      }).observe(mainBtn);
    }

    /* Descripcion: "Ver mas" si es larga */
    var desc = $('[data-desc]', root);
    if (desc) {
      var body = $('[data-desc-body]', desc), tog = $('[data-desc-toggle]', desc);
      var check = function () {
        if (desc.classList.contains('is-open')) return;
        var long = body.scrollHeight > body.clientHeight + 4;
        tog.hidden = !long;
        desc.classList.toggle('is-clamped', long);
      };
      check();
      window.addEventListener('load', check);
      tog.addEventListener('click', function () {
        var open = !desc.classList.contains('is-open');
        desc.classList.toggle('is-open', open);
        desc.classList.toggle('is-clamped', !open);
        tog.setAttribute('aria-expanded', open ? 'true' : 'false');
        $('[data-desc-more]', tog).hidden = open;
        $('[data-desc-less]', tog).hidden = !open;
        if (!open) desc.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }

    /* Personas viendo el producto (numero simulado dentro del rango configurado) */
    var viewers = $('[data-viewers]', root);
    if (viewers) {
      var nEl = $('[data-viewers-n]', viewers);
      var min = Number(viewers.dataset.min) || 5, max = Number(viewers.dataset.max) || 20;
      if (max < min) { var tmp = min; min = max; max = tmp; }
      var key = 'icase-viewers-' + viewers.dataset.productId, n = 0;
      try { n = Number(sessionStorage.getItem(key)) || 0; } catch (err) {}
      if (n < min || n > max) n = min + Math.floor(Math.random() * (max - min + 1));
      var show = function () {
        nEl.textContent = n;
        try { sessionStorage.setItem(key, n); } catch (err) {}
      };
      show();
      viewers.hidden = false;
      var tick = function () {
        var step = Math.floor(Math.random() * 3) - 1;
        n = Math.min(max, Math.max(min, n + step));
        show();
        setTimeout(tick, 7000 + Math.random() * 9000);
      };
      setTimeout(tick, 7000 + Math.random() * 9000);
    }

    root.addEventListener('click', function (e) {
      /* Cantidad - / + */
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var input = $('input[name="quantity"]', step.parentNode);
        if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep));
        return;
      }
      /* Ventanitas de los sellos */
      var opener = e.target.closest('[data-modal-open]');
      if (opener) {
        var dlg = document.getElementById(opener.dataset.modalOpen);
        if (dlg && dlg.showModal) dlg.showModal();
        return;
      }
      if (e.target.closest('[data-modal-close]')) { var d = e.target.closest('dialog'); if (d) d.close(); return; }
      if (e.target.matches && e.target.matches('dialog.modal')) { e.target.close(); return; }
      /* Botón de la barra fija */
      if (e.target.closest('[data-sticky-add]') && mainBtn) mainBtn.click();
    });
  });
})();
